/***********************************************************************
 * Registration form for new users. 🐺
 * ***********************************
 *
 * @format */

import React, {useState} from 'react';

import useNewAccount from 'frontier/account/components/auth/new_account/use_new_account';
import {PasswordValidator} from 'frontier/utilities/password_validator';
import {TextLink, Button} from '@sttark/design-system';
import {ConditionalButton} from 'frontier-utilities';
import {InputWithErrorHandler} from 'frontier-form';
import ErrorDisplay from 'frontier/utilities/error';

// styles
import './new_account.sass';

export default function CheckoutNewAccount({redirect, loginButtonLabel, onLogin}) {
    const {
        onInputChange,
        isSubmitting,
        onKeyPress,
        isComplete,
        first_name,
        onSubmit,
        password,
        company,
        email,
        phone,
        error
    } = useNewAccount({redirect, onLogin});

    return (
        <>
            <div className="checkout-new-account">
                {error && (
                    <div style={{color: 'red', fontSize: '90%'}}>
                        <ErrorDisplay error={error} />
                    </div>
                )}

                <>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-6 form-group_field">
                                <InputWithErrorHandler
                                    onChange={onInputChange.bind(this, 'full_name')}
                                    placeholder="* Enter your full name"
                                    onKeyUp={onKeyPress}
                                    errorPath={'name'}
                                    value={first_name}
                                    label="*Full Name"
                                    name="full_name"
                                    newestds={true}
                                    error={error}
                                    type="text"
                                />
                            </div>
                            <div className="col-md-6 form-group_field">
                                <InputWithErrorHandler
                                    onChange={onInputChange.bind(this, 'phone')}
                                    placeholder="* Enter you phone number"
                                    onKeyUp={onKeyPress}
                                    errorPath={'phone'}
                                    newestds={true}
                                    label="*Phone"
                                    value={phone}
                                    error={error}
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 form-group_field">
                                <InputWithErrorHandler
                                    onChange={onInputChange.bind(this, 'company')}
                                    placeholder="* Enter your company name"
                                    errorPath={'company_entity.name'}
                                    label="* Company Name"
                                    onKeyUp={onKeyPress}
                                    value={company}
                                    newestds={true}
                                    error={error}
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-6 form-group_field">
                                <InputWithErrorHandler
                                    autoComplete="off"
                                    onKeyUp={onKeyPress}
                                    onChange={onInputChange.bind(this, 'email')}
                                    label="*Email (this will be your username)"
                                    placeholder="* Enter email address"
                                    errorPath={'email'}
                                    newestds={true}
                                    value={email}
                                    error={error}
                                    type="text"
                                />
                            </div>
                            <div className="col-md-6 form-group_field">
                                <InputWithErrorHandler
                                    autoComplete="off"
                                    onChange={onInputChange.bind(this, 'password')}
                                    placeholder="* Enter your desired Password"
                                    errorPath={'password'}
                                    onKeyUp={onKeyPress}
                                    value={password}
                                    label="*Password"
                                    type="password"
                                    newestds={true}
                                    error={error}
                                    minLength="5"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="save-btn row">
                        <div className="col-md-6">
                            <ConditionalButton enabled={!isSubmitting}>
                                <Button primary label={loginButtonLabel} onClick={onSubmit} />
                                <Button primary label={'Saving...'} onClick={() => {}} disabled />
                            </ConditionalButton>
                        </div>

                        <div className="col-md-6">
                            {password && <PasswordValidator input={password} />}
                        </div>
                    </div>
                </>
            </div>
        </>
    );
}
